var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"heading-with-description"},[_c('Heading',{attrs:{"text":_vm.textHeading,"size":_vm.sizeHeading}}),_c('p',{staticClass:"heading-with-description__description",domProps:{"textContent":_vm._s(_vm.textDescription)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }